exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".HTYlODRvaymQ5iZBEw4am{margin:0}._1Z3nc0t8s5DIC3zGhjsKJR{margin:0;padding-top:.5em}._2yAAFCQQGT5CyHUdhA56md{margin-bottom:0}._7EYjBL41F7RisJm9r95Wv{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2x14Wkwnp4yBdfdZ6AsP4s{padding-bottom:0;padding-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AssessmentResultsCard_container": "_20LKzJHlh_01Lh-5_7PMio",
	"AssessmentResultsCard_grid": "HTYlODRvaymQ5iZBEw4am",
	"AssessmentResultsCard_item": "_1Z3nc0t8s5DIC3zGhjsKJR",
	"AssessmentResultsCard_totalScoreRow": "_2yAAFCQQGT5CyHUdhA56md",
	"AssessmentResultsCard_heading": "_7EYjBL41F7RisJm9r95Wv",
	"AssessmentResultsCard_content": "_2x14Wkwnp4yBdfdZ6AsP4s"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/AssessmentResultsCard/style.postcss
// module id = 2022
// module chunks = 0